import { Box, Button, Container, Paper } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../app/store';
import Header from '../components/Header';
import PhotoCapture from '../components/PhotoCapture';
import { update } from '../features/inputSlice';

const SCREEN = 'certificate';

const Certificate = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const input = useSelector((state: RootState) => state.input);

  useEffect(() => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleBack = (event: React.MouseEvent<HTMLButtonElement>) => {
    navigate("/input");
  };

  const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement>) => {
    console.log(input);
    navigate("/signature");
  };

  const handleChildData = (file: string) => {
    dispatch(update({ key: 'certificate', value: file }));
    console.log(input);
  };

  return (
    <Container maxWidth="xs">
      <Paper elevation={3} style={{ padding: '2rem', marginTop: '2rem' }}>
        <Header title={t(`${SCREEN}.title`)} />
        <PhotoCapture onSendData={handleChildData} />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2, gap: 2 }}>
          <Button
            variant="outlined"
            color="primary"
            fullWidth
            onClick={handleBack}
            style={{ marginTop: '1rem' }}
          >
            {t(`${SCREEN}.back`)}
          </Button>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleSubmit}
            style={{ marginTop: '1rem' }}
          >
            {t(`${SCREEN}.next`)}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}

export default Certificate;
